var map = {
	"./adult/nn/readingtest-questions.json": 666,
	"./adult/no/readingtest-questions.json": 667,
	"./youth/de/readingtest-questions.json": 668,
	"./youth/nn/readingtest-questions.json": 669,
	"./youth/no/readingtest-questions.json": 670,
	"./youth/se/readingtest-questions.json": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 665;